var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"md-cols":"4"}}),_c('v-col',{attrs:{"md-cols":"4"}},[_c('router-view')],1),_c('v-col',{attrs:{"md-cols":"4"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }